import { useInstantSearch, useRefinementList } from 'react-instantsearch';
import { FormattedMessage } from 'react-intl';

import { PlayerPlayingStatus } from '@sorare/core/src/__generated__/globalTypes';
import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { SwitchIcon } from '@sorare/core/src/atoms/icons/SwitchIcon';
import { FILTERS } from '@sorare/core/src/lib/filters';

const startersFilter = FILTERS.playingStatus;

const STARTER = [PlayerPlayingStatus.STARTER, PlayerPlayingStatus.REGULAR];

export const StartersFilter = () => {
  const { items, refine } = useRefinementList({
    attribute: startersFilter.attribute,
  });
  const { indexUiState } = useInstantSearch();

  const isPlayingStatusRefined = (ps: PlayerPlayingStatus) =>
    items
      .map(({ value, isRefined }) => isRefined && value.toUpperCase())
      .filter(Boolean)
      .includes(ps);

  const isChecked = STARTER.every(ps =>
    indexUiState.refinementList?.[startersFilter.attribute]?.includes(
      ps.toLowerCase()
    )
  );

  const notRefinedPlayingStatus = STARTER.filter(
    ps => !isPlayingStatusRefined(ps)
  );

  const someAreChecked =
    notRefinedPlayingStatus.length > 0 &&
    notRefinedPlayingStatus.length < STARTER.length;

  const onClick = () => {
    if (someAreChecked) {
      notRefinedPlayingStatus.map(playingStatus =>
        refine(playingStatus.toLowerCase())
      );
      return;
    }
    STARTER.map(ps => refine(ps.toLowerCase()));
  };

  return (
    <Button color="tertiary" size="small" onClick={onClick}>
      <FormattedMessage
        id="searchCommonPlayer.startersFilter"
        defaultMessage="Starters"
      />
      <SwitchIcon size="small" checked={isChecked} />
    </Button>
  );
};
